"use client";
import { RichText as e } from "../RichText/RichText.mjs";
import { Text as t } from "../Text/Text.mjs";
import { Arrow as n, Content as r, Portal as i, Provider as a, Root as o, Trigger as s } from "@radix-ui/react-tooltip";
import { forwardRef as c, useEffect as l, useState as u } from "react";
import { twMerge as d } from "tailwind-merge";
import { jsx as f, jsxs as p } from "react/jsx-runtime";
//#region src/components/atoms/Tooltip/Tooltip.tsx
function m() {
	try {
		return matchMedia("(hover: hover)").matches;
	} catch {
		return !0;
	}
}
var h = c(({ className: a = "", contentProps: c = {}, description: h, descriptionHtml: g, hasArrow: _ = !0, title: v, trigger: y, variant: b = "dark", triggerProps: x = {}, ...S }, C) => {
	let [w, T] = u(!1);
	l(() => {
		S?.defaultOpen && T(!0);
	}, [S?.defaultOpen]);
	let E = d(`rounded shadow-level1-soft p-3 z-[1050] ${b === "light" ? "bg-white text-black" : "bg-black text-white"}`, a), D = h || g ? "semibold" : "regular";
	return m() || (S = {
		...S,
		open: w,
		onOpenChange: () => T(!1)
	}, x = {
		...x,
		onClick: () => T(!0)
	}), /* @__PURE__ */ p(o, {
		delayDuration: 0,
		...S,
		children: [/* @__PURE__ */ f(s, {
			ref: C,
			asChild: !0,
			...x,
			children: y
		}), (v || h || g) && /* @__PURE__ */ f(i, { children: /* @__PURE__ */ p(r, {
			"data-testid": "tooltip-content",
			className: E,
			sideOffset: 4,
			hideWhenDetached: !0,
			...c,
			children: [_ && /* @__PURE__ */ f(n, {
				className: `fill-current drop-shadow-level1-soft mask-clip ${b === "light" ? "text-white" : "text-black"}`,
				style: { clipPath: "inset(0 -10px -10px -10px)" }
			}), /* @__PURE__ */ p("div", {
				className: "flex flex-col gap-y-1.5 max-w-xs",
				children: [v && /* @__PURE__ */ f(t, {
					fontSize: "sm",
					fontWeight: D,
					asChild: !0,
					children: /* @__PURE__ */ f("span", { children: v })
				}), g ? /* @__PURE__ */ f(e, {
					content: g,
					className: "text-xs [&_*]:text-xs",
					fontFamily: b === "light" ? "polysans" : "inter"
				}) : h ? /* @__PURE__ */ f(t, {
					fontSize: "xs",
					fontWeight: "regular",
					children: h
				}) : null]
			})]
		}) })]
	});
});
h.displayName = "Tooltip";
//#endregion
export { h as Tooltip, a as TooltipProvider };
